module.exports = __webpack_public_path__ + "media/05 wormwood.e4f0b591.mp3";